/**
 * Fechas en formato dd/mm/aaaa y zona horaria America/Argentina/Cordoba.
 *
 * Las fechas de negocio (fecha de romaneo, de comprobante, de movimiento) viajan como
 * texto ISO 'aaaa-mm-dd' sin hora. Asi no hay corrimiento de dia al cruzar zonas, que
 * es el error clasico cuando se usa Date para representar un dia calendario.
 */

export const ZONA_HORARIA = 'America/Argentina/Cordoba';

/** Fecha de negocio: un dia calendario, sin hora ni zona. Formato 'aaaa-mm-dd'. */
type FechaISO = string;

const RE_FECHA_ISO = /^\d{4}-\d{2}-\d{2}$/;

export function esFechaISOValida(valor: string): boolean {
  if (!RE_FECHA_ISO.test(valor)) return false;
  const [anio, mes, dia] = valor.split('-').map(Number) as [number, number, number];
  const fecha = new Date(Date.UTC(anio, mes - 1, dia));
  return (
    fecha.getUTCFullYear() === anio && fecha.getUTCMonth() === mes - 1 && fecha.getUTCDate() === dia
  );
}

/** '2026-09-29' -> '29/09/2026'. */
export function formatearFecha(fecha: FechaISO): string {
  if (!esFechaISOValida(fecha)) return fecha;
  const [anio, mes, dia] = fecha.split('-') as [string, string, string];
  return `${dia}/${mes}/${anio}`;
}

/** Fecha de hoy en Cordoba, como 'aaaa-mm-dd'. */
export function hoy(ahora: Date = new Date()): FechaISO {
  const partes = new Intl.DateTimeFormat('en-CA', {
    timeZone: ZONA_HORARIA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(ahora);
  return partes;
}

/** Fecha y hora completas para auditoria: '29/09/2026 14:35'. */
export function formatearFechaHora(iso: string): string {
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return iso;
  return new Intl.DateTimeFormat('es-AR', {
    timeZone: ZONA_HORARIA,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(fecha);
}
